import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response, ResponseContentType } from '@angular/http';
import { HttpClientModule, HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';

import { Observable } from 'rxjs/Rx'
import { Subject } from 'rxjs/Subject';

import { Advisor } from '../models/advisor';
import { Client } from '../models/client';
import { Organization } from '../models/organization';

import { saveAs } from 'file-saver';

import { Router } from '@angular/router';

import Utils from '../shared/utility';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

// const env = 'https://apidev.hvsfinancial.com/api/';
//const env = 'http://api.hvsfinancial.com.loc/api/';
// const env = 'https://hvsportalpentestsvc.hvsfinancial.com/api/'; //zss PENTEST SERVICE
// const env = 'https://apiuat2.hvsfinancial.com/api/'; //zss uat build
//const env = 'https://apiuat3.hvsfinancial.com/api/';

//PROD
const env = 'https://apidev3.hvsfinancial.com/api/'; //zss prod build

@Injectable()
export class GlobalService {
  constructor(private _http: HttpClient,private http: Http, private router: Router) { }
  breadcrumbList: Array<any> = [];
  // 1 = SUPER ADMIN
  // 2 = ORGANIZATION ADMIN
  // 3 = ADVISOR
  // 4 = CLIENT

  hasSetFeatures = false;
  orgAccess;
  features;
  featHealthCare: boolean = false;//true;
  featMeansTesting: boolean = false;//true;
  featSocialSecurity: boolean = false;//true;
  featLongTermCare: boolean = false;//true;
  featTitan: boolean;
  featRiskTolerance: boolean;
  featHomeOffice: boolean;

  isHVAM: boolean;

  displayFAB: boolean = true;


  getAdvisorsData(UserType = 2): Observable<any[]> {
    let body = { UserType };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/GetUsers', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  getReportsData(): Observable<any> {
    let body = { UserID: 2 };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/GetReports', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  getLegacyReportsData(): Observable<any> {
    let body = { };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/GetUserLegacyReports', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  getReportData(): Observable<any> {
    let body = { UserID: 2, ReportID: 1, ReportTypeID: 2 };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/GetReport', body, options)
      .map((res: Response) => {

        return res.json();
      })
      .catch(this.handleError);
  }

  getClientReportsData(UserID: number): Observable<any> {
    let body = { UserID };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/GetClientReports', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  getAdvisorData(UserID: number): Observable<Advisor> {
    let body = { UserID: UserID };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/GetUser', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  getClientsData(): Observable<any[]> {
    let body = { UserType: 3 };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/GetUsers', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  getClientData(UserID: number, UserType: number): Observable<any> {

    if(!this.hasSetFeatures){
      //call/set features
      this.getOrganizationsFeatures();
    }

    let body = { UserID: UserID, UserType: UserType };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/GetUser', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  getOrganizationsFeatures(){
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    this.http.post(env + 'CoreOrganization/GetOrgFeatures', JSON.stringify({ ID: (localStorage.getItem('parentID') != '0') ? localStorage.getItem('parentID') : localStorage.getItem('orgID')}), options).map((response: Response) => {
      let resp = response.json();
      //if array is empty; allow all
      this.orgAccess = resp;
      if(resp.length > 0){
        for(let value of resp){

          if(value.FeatureTypeID == 1){
            this.featRiskTolerance = true;
          }else if(value.FeatureTypeID === 2){
            this.featHealthCare = true;
          }else if(value.FeatureTypeID == 3){
            this.featSocialSecurity = true;
          }else if(value.FeatureTypeID == 4){
            this.featLongTermCare = true;
          }else if(value.FeatureTypeID == 5){
            this.featTitan = true;
          }else if(value.FeatureTypeID == 6){
            this.featHomeOffice = true;
          }else if(value.FeatureTypeID == 7){
            this.featMeansTesting = true;
          }

        }
        
      }else{
        //not in table => lets preset the basic tool/default
        this.featHealthCare = true;
        this.featLongTermCare = true;
        this.featSocialSecurity = true;
        this.featTitan = true;   
        this.featMeansTesting = true;

        this.featRiskTolerance = false;
        this.featHomeOffice = false;
      }
      
      this.hasSetFeatures = true;

      localStorage.setItem('featRiskTolerance', JSON.stringify(this.featRiskTolerance));
      localStorage.setItem('featHomeOffice', JSON.stringify(this.featHomeOffice));
      localStorage.setItem('featMeansTesting', JSON.stringify(this.featMeansTesting));
      localStorage.setItem('featLongTermCare', JSON.stringify(this.featLongTermCare));
      localStorage.setItem('featSocialSecurity', JSON.stringify(this.featSocialSecurity));
      localStorage.setItem('featHealthCare', JSON.stringify(this.featHealthCare));
    });
  }

  getOrganizationsData(): Observable<Organization[]> {
    let body = {};
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/GetOrganizations', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  getOrganizationData(OrgID: number): Observable<any> {
    let body = { ID: OrgID  };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/GetOrganization', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }


  getMMTGraphData(client: any, mmtInputs: any, user): Observable<any> {
    let People = [{
      Gender: client.client.GenderID,
      CurrentIncome: client.clientProfile.CurrentIncome,
      DateOfBirth: client.client.DOB,
      conditions: client.clientProfile.HealthConditions || [], // Fix this
      RetirementAge: client.clientProfile.RetirementAge,
      RetirementState: client.clientProfile.RetirementState,
      PensionAmount: client.clientProfile.Pension,
      SocialSecurityPia: mmtInputs.SSMonthlyBenefit,
      SocialSecurityRetirementAge: mmtInputs.SocialSecurityRetirementAge,
      LifeExpectancy: client.clientProfile.LifeExpectancy || 0,
    }];

    if (mmtInputs.IncludePartner) {
      let partnerPensionAmout = Number(client.clientProfile.Spouses[0].pension);
      People.push({
        Gender: client.clientProfile.Spouses[0].gender,
        CurrentIncome: client.clientProfile.Spouses[0].currentIncome,
        DateOfBirth: client.clientProfile.Spouses[0].dob,
        conditions: client.clientProfile.Spouses[0].healthConditions || [], // Fix this
        RetirementAge: client.clientProfile.Spouses[0].retirementAge,
        PensionAmount: partnerPensionAmout,
        SocialSecurityPia: mmtInputs.PartnerSSMonthlyBenefit,
        SocialSecurityRetirementAge: mmtInputs.PartnerSocialSecurityAge,
        RetirementState: client.clientProfile.Spouses[0].state,
        LifeExpectancy: client.clientProfile.Spouses[0].LifeExpectancy || 0,
      });

    }

    let body = { People, IRR: client.clientProfile.IRR , HCModelVersion: 6, SalaryIncrease: mmtInputs.InflationRate, retirementState: client.clientProfile.RetirementState, PercentIncomeMAGI: mmtInputs.MagiIncomePercent, clientProfile: JSON.stringify(client.clientProfile), CompanyCode: user.CompanyCode, UserID: user.UserID, ClientID: user.ClientID }; // TODO: Grab organization HCModelVersion
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreReports/MedicareMeansTestingGraph', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  // TODO: Update to use proper models instead of `any`
  getMMTData(client: any, mmtInputs: any, user): Observable<any> {
    let People = [{
      Gender: client.client.GenderID,
      CurrentIncome: client.clientProfile.CurrentIncome,
      DateOfBirth: client.client.DOB,
      conditions: client.clientProfile.HealthConditions || [], // Fix this
      RetirementAge: client.clientProfile.RetirementAge,
      RetirementState: client.clientProfile.RetirementState,
      PensionAmount: client.clientProfile.Pension,
      SocialSecurityPia: mmtInputs.SSMonthlyBenefit,
      SocialSecurityRetirementAge: mmtInputs.SocialSecurityRetirementAge,
      LifeExpectancy: client.clientProfile.LifeExpectancy || 0,
    }];

    if (mmtInputs.IncludePartner) {
      People.push({
        Gender: client.clientProfile.Spouses[0].gender,
        CurrentIncome: client.clientProfile.Spouses[0].currentIncome,
        DateOfBirth: client.clientProfile.Spouses[0].dob,
        conditions: client.clientProfile.Spouses[0].healthConditions || [], // Fix this
        RetirementAge: client.clientProfile.Spouses[0].retirementAge,
        PensionAmount: client.clientProfile.Spouses[0].pension,
        SocialSecurityPia: mmtInputs.PartnerSSMonthlyBenefit,
        SocialSecurityRetirementAge: mmtInputs.PartnerSocialSecurityAge,
        RetirementState: client.clientProfile.Spouses[0].state,
        LifeExpectancy: client.clientProfile.Spouses[0].LifeExpectancy || 0,
      });

      // client.clientProfile.Spouses = JSON.parse(client.clientProfile.Spouses);
    }

    let body = { People, IRR: client.clientProfile.IRR , HCModelVersion: 6, SalaryIncrease: mmtInputs.InflationRate, retirementState: client.clientProfile.RetirementState, PercentIncomeMAGI: mmtInputs.MagiIncomePercent, clientProfile: JSON.stringify(client.clientProfile), CompanyCode: user.CompanyCode, UserID: user.UserID, ClientID: user.ClientID }; // TODO: Grab organization HCModelVersion
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreReports/MedicareMeansTestingReport', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  // TODO: Update to use proper models instead of `any`
  getSSData(ssInputs, user): Observable<any> {

    let body = { SSRequestObject: ssInputs, CompanyCode: user.CompanyCode, UserID: user.UserID, ClientID: user.ClientID  }; // TODO: Grab organization HCModelVersion
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    return this.http.post(env + 'CoreReports/SocialSecurityReport', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  getLTCData(ltcData: any, queryInfo: any): Observable<any> {
    let body = { ltcData, clientID: queryInfo.clientID, userID: queryInfo.userID, orgID: queryInfo.orgID, clientRetirementAge: queryInfo.clientRetirementAge };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreReports/LongTermCareReport', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  // TODO: Update to use proper models instead of `any`
  getHCData(client: any, pExpenses: any, oopExpenses: any, spouse: any, includePartner: boolean): Observable<any> {
    let People = [{
      CurrentAge: client.clientProfile.CurrentAge,
      Gender: client.client.GenderID,
      CurrentIncome: client.clientProfile.CurrentIncome,
      RetirementAge: client.clientProfile.RetirementAge,
      RetirementState: client.clientProfile.RetirementState,
      DateOfBirth: client.client.DOB,
      conditions: JSON.stringify({
        HCHBP: client.clientProfile.HCHBP,
        HCHC: client.clientProfile.HCHC,
        HCT2D: client.clientProfile.HCT2D,
        HCCD: client.clientProfile.HCCD,
        HCC: client.clientProfile.HCC,
        HCT: client.clientProfile.HCT,
      })
    }];

    if (includePartner) {
      People.push({
        CurrentAge: 0,
        Gender: spouse.gender,
        CurrentIncome: spouse.currentIncome,
        RetirementAge: spouse.retirementAge,
        RetirementState: client.clientProfile.RetirementState,
        DateOfBirth: spouse.dob,
        conditions: JSON.stringify({
          HCHBP: client.clientProfile.Spouses[0].HCHBP,
          HCHC: client.clientProfile.Spouses[0].HCHC,
          HCT2D: client.clientProfile.Spouses[0].HCT2D,
          HCCD: client.clientProfile.Spouses[0].HCCD,
          HCC: client.clientProfile.Spouses[0].HCC,
          HCT: client.clientProfile.Spouses[0].HCT,
        })
      });
    }

    let premiumExpenses = {
      partB: pExpenses.partB,
      partD: pExpenses.partD,
      medigap: pExpenses.medigap,
      dental: pExpenses.dental
    }

    let outOfPocketExpenses = {
      hospitalization: oopExpenses.hospitalization,
      docsTests: oopExpenses.docsTests,
      rx: oopExpenses.rx,
      dental: oopExpenses.dental,
      hearingServices: oopExpenses.hearingServices,
      vision: oopExpenses.vision,
      commercial: oopExpenses.commercial
    }

    let body = { People, HCModelVersion: 6, retirementState: client.clientProfile.RetirementState, premiumExpenses, outOfPocketExpenses, clientProfile: JSON.stringify(client.clientProfile) }; // TODO: Grab organization HCModelVersion
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });


    return this.http.post(env + 'CoreReports/HealthCareReport', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }


  getHCDataV2(ReportHC, user): Observable<any> {
    let body = { ReportHC, CompanyCode: user.CompanyCode, UserID: user.UserID, ClientID: user.ClientID   }; // TODO: Grab organization HCModelVersion
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });


    return this.http.post(env + 'CoreReports/HealthCareReportV2', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  createOrganization(OrganizationModel: any) {
    let body = OrganizationModel;
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/UpdateOrganization', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  generateLegacyReport(report) {
    let body = { report };
    let headers = new Headers({ 
      'Authorization': `bearer ${localStorage.getItem('bearer')}`,
      'Accept': 'application/pdf',
    });

    return this.http.post(env + 'CoreOrganization/DownloadableLegacyReport', body, { responseType: ResponseContentType.Blob, headers  })
      .map((res: Response) => {
        var blob = new Blob([res.blob()], { type: 'application/pdf' });
        var reportName = report.title;

        if (report.reportTypeID) {
          reportName += report.reportTypeID == 1 ? "Social_Security_Report" : report.reportTypeID == 2 ? "Means_Testing_Report" : "Health_Care_Report";
        } else {
          reportName += report.ReportTypeID == 1 ? "Social_Security_Report" : report.ReportTypeID == 2 ? "Means_Testing_Report" : "Health_Care_Report";
        }
        
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, reportName + '.pdf');
        }
        else {
          var url = window.URL.createObjectURL(blob);
          window.open(url);
          saveAs(blob, reportName + ".pdf");
        }

        return res.json();
      })
      .catch(this.handleError);
  }

  generateRiskToleranceHealthcareReport(ReportFields, client, report) {
    let body = { ReportFields };
    let headers = new Headers({ 
      'Authorization': `bearer ${localStorage.getItem('bearer')}`,
      'Accept': 'application/pdf',
    });

    return this.http.post(env + 'GenReport/GetRiskToleranceHealthcareReport', body, { responseType: ResponseContentType.Blob, headers  })
    .map((res) => {        
      return res.json();
    })
    .catch(this.handleError);
  }

  generateReport(ReportFields, client, report) {
    let body = { ReportFields };
    let headers = new Headers({ 
      'Authorization': `bearer ${localStorage.getItem('bearer')}`,
      'Accept': 'application/pdf',
    });

    let reportUrl =  'GetDownloadableReport';

    if (Number(report.ReportTypeID || report.reportTypeID) == 5) {
      reportUrl = 'GetRiskToleranceHealthcareReport';
    } else if (Number(report.ReportTypeID || report.reportTypeID) == 7) {
      reportUrl = 'GetRiskToleranceLongtermCareReport'
    }

    return this.http.post(env + `GenReport/${reportUrl}`, body, { responseType: ResponseContentType.Blob, headers  })
      .map((res: Response) => {        
        var blob = new Blob([res.blob()], { type: 'application/pdf' });

        if (client.FirstName) {
          var reportName = client.FirstName + "_" + client.LastName + "_";
        } else {
          var reportName = client.firstName + "_" + client.lastName + "_";
        }
        
        let type = "";
      
        switch(Number(report.ReportTypeID || report.reportTypeID)) {
          case 1:
            type = 'Social_Security_Report'
            break;
          case 2:
            type = 'Medicare_Means_Testing_Report'
            break;
          case 3:
            type = 'Healthcare_Report'
            break;
          case 4:
            type = 'Longterm_Care_Report'
            break;
          case 5:
            type = 'Risk_Tolerance_Healthcare_Report'
            break;
          case 6:
            type = 'Risk_Tolerance_Social_Security_Report'
            break;
          case 7:
            type = 'Risk_Tolerance_Longterm_Care_Report'
            break;
          default:
            break;
        }

        reportName += type;

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, reportName + '.pdf');
        } else {
          var url = window.URL.createObjectURL(blob);
          window.open(url);
          saveAs(blob, reportName + ".pdf");
        }

        return res.json();
      })
      .catch(this.handleError);
  }
  
  createReport(Report: any, ReportMMT: any) {
    let body = { Report, ReportMMT };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/CreateMMTReport', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  createReportHC(Report: any, ReportHC: any) {
    let body = { Report, ReportHC };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    let reportUrl = Report.ReportTypeID == 3 ? 'CreateHCReport' : 'CreateHCRiskToleranceReport';

    return this.http.post(env + `CoreOrganization/${reportUrl}`, body, options)
      .map((res: Response) => {
        var result = res.json();
        return res.json();
      })
      .catch(this.handleError);
  }

  createReportLTC(Report: any, ReportLTC: any) {
    let body = { Report, ReportLTC };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    let reportUrl = Report.ReportTypeID == 4 ? 'CreateLTCReport' : 'CreateLTCRiskToleranceReport';

    return this.http.post(env + `CoreOrganization/${reportUrl}`, body, options)
      .map((res: Response) => {
        var result = res.json();
        return res.json();
      })
      .catch(this.handleError);
  }

  createReportSS(Report: any, ReportSS: any) {
    let body = { Report, ReportSS };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/CreateSSReport', body, options)
      .map((res: Response) => {
        var result = res.json();
        return res.json();
      })
      .catch(this.handleError);
  }

  createClient(UserModel: any, ClientProfile: any, RiskTolerance: any): Observable<any> {
    let body = { UserModel, ClientProfile, RiskTolerance };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/UpdateClient', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  createAdvisor(UserModel: any): Observable<any> {
    let body = { UserModel };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/UpdateAdvisor', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  updateAdvisor(UserModel: any): Observable<any> {
    let body = { UserModel };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/UpdateAdvisor', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  UploadOrgDoc(formData: any): Observable<any> {
    let headers = new Headers({ 'Authorization': `bearer ${localStorage.getItem('bearer')}` });

    let options = new RequestOptions({ headers: headers });

    return this.http.post(env + 'CoreOrganization/UploadOrgDoc', formData, options)
      .map((res: Response) => {
        return res;
      })
      .catch(this.handleError);
  }

  uploadOrgLogo(formData: any): Observable<any> {
    // let headers = new Headers();
    let headers = new Headers({ 'Authorization': `bearer ${localStorage.getItem('bearer')}` });

    let options = new RequestOptions({ headers: headers });
    // let apiUrl1 = "http://api.hvsfinancial.com.loc/api/CoreRegistration/UploadProfilePhoto";

    return this.http.post(env + 'CoreOrganization/UploadOrgLogo', formData, options)
      .map((res: Response) => {
        return res;
      })
      .catch(this.handleError);
  }

  saveProfileImage(formData: any): Observable<any> {
    // let headers = new Headers();
    let headers = new Headers({ 'Authorization': `bearer ${localStorage.getItem('bearer')}` });

    let options = new RequestOptions({ headers: headers });
    // let apiUrl1 = "http://api.hvsfinancial.com.loc/api/CoreRegistration/UploadProfilePhoto";

    return this.http.post(env + 'CoreOrganization/UploadProfilePhoto', formData, options)
      .map((res: Response) => {
        return res;
      })
      .catch(this.handleError);

  }

  getProfileImage(): Observable<any> {
    let headers = new Headers({ 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers: headers });

    return this.http.post(env + 'CoreOrganization/GetProfileImage', {}, options)
      .map((res: Response) => {
        return res;
      })
      .catch(this.handleError);
  }

  createSupportTicket(SupportModel: any): Observable<any> {
    let body = { SupportModel };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/CreateSupportTicket', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  consumerTools(UserModel: any): Observable<any> {
    let body = { UserModel };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/ConsumerTools', body, options)
      .map((res: any) => {
        return res._body;
      })
      .catch(this.handleError);
  }

  getPIA(PIACalculator: any): Observable<any> {
    let body = { PIACalculator };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    return this.http.post(env + 'CoreReports/GetPIA', body, options)
      .map((res: any) => {
        return res._body;
      })
      .catch(this.handleError);
  }

  getLE(LEObject: any): Observable<any> {
    let body = { LEObject };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    
    return this.http.post(env + 'CoreReports/GetLE', body, options)
      .map((res: any) => {
        return res._body;
      })
      .catch(this.handleError);
  }

  getMetrics(): Observable<any> {
    let body = {};
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    
    return this.http.post(env + 'CoreOrganization/GetMetrics', body, options)
      .map((res: any) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  getUnassignedLeads(): Observable<any> {
    let body = {};
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    
    return this.http.post(env + 'CoreOrganization/GetUnassignedLeads', body, options)
      .map((res: any) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  getUserLeads(): Observable<any> {
    let body = {};
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    
    return this.http.post(env + 'CoreOrganization/GetUserLeads', body, options)
      .map((res: any) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  getLeadInfo(leadRelationshipId): Observable<any> {
    let body = { LeadRelationshipId : leadRelationshipId };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    
    return this.http.post(env + 'CoreOrganization/GetLeadInfo', body, options)
      .map((res: any) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  assignLead(leadRelationshipId, advisorId): Observable<any> {
    let body = { LeadRelationshipId : leadRelationshipId, AdvisorID: advisorId  };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    
    return this.http.post(env + 'CoreOrganization/ReassignLead', body, options)
      .map((res: any) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  archiveLead(leadRelationshipId): Observable<any> {
    let body = { LeadRelationshipId : leadRelationshipId };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    
    return this.http.post(env + 'CoreOrganization/ArchiveLead', body, options)
      .map((res: any) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  updateOrgInfo(org): Observable<any> {
    let body = { Organization : org };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    
    return this.http.post(env + 'CoreOrganization/UpdateOrgInfo', body, options)
      .map((res: any) => {
      })
      .catch(this.handleError);
  }

  UploadDocumentItem(doc): Observable<any> {
    let body = { Document : doc };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    
    return this.http.post(env + 'CoreOrganization/UploadDocumentItem', body, options)
      .map((res: any) => {
        return res; //.json();
      })
      .catch(this.handleError);
  }

  GetMarketingMaterial(): Observable<any> {
    let body = { };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    
    return this.http.post(env + 'CoreOrganization/GetMarketingMaterial', body, options)
      .map((res: any) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  ReplaceInfoCenter(infoCenter): Observable<any> {
    let body = { infoCenter: JSON.stringify(infoCenter) };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    
    return this.http.post(env + 'CoreOrganization/ReplaceInfoCenter', body, options)
      .map((res: any) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  ReplaceMarketingMaterial(marketingMaterial): Observable<any> {
    let body = { marketingMaterial: JSON.stringify(marketingMaterial) };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    
    return this.http.post(env + 'CoreOrganization/ReplaceMarketingMaterial', body, options)
      .map((res: any) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  GetPaymentToken(): Observable<any> {
    let body = { };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    
    return this.http.post(env + 'CoreOrganization/GetPaymentToken', body, options)
      .map((res: any) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  CompletePayment(obj): Observable<any> {
    let body = { obj };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    
    return this.http.post(env + 'CoreRegistration/CompletePayment', body, options)
      .map((res: any) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  GetPricing(obj): Observable<any> {
    let body = obj;
    let headers = new Headers({ 'Content-Type': 'application/json','Accept': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    
    return this.http.post(env + 'CoreRegistration/GetPricing', body, options)
      .map((res: any) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  GetInfoCenter(): Observable<any> {
    let body = { };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    
    return this.http.post(env + 'CoreOrganization/GetInfoCenter', body, options)
      .map((res: any) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  getMetricDataLegacy(metricObject): Observable<any> {
    let body = metricObject;
    let headers = new Headers({ 
      'Authorization': `bearer ${localStorage.getItem('bearer')}`,
      'Accept': 'application/vnd.ms-excel',
    });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/GetOrganizationMetricsLegacy', body, { responseType: ResponseContentType.Blob, headers  })
      .map((res: Response) => {        
        var blob = new Blob([res.blob()], { type: 'application/vnd.ms-excel' });

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, 'metric-data.xlsx');
        }
        else {
          var url = window.URL.createObjectURL(blob);
          window.open(url);
          saveAs(blob, 'metric-data.xlsx');
        }
      })
      .catch(this.handleError);
  }

  getMetricData(metricObject): Observable<any> {
    let body = metricObject;
    let headers = new Headers({ 
      'Authorization': `bearer ${localStorage.getItem('bearer')}`,
      'Accept': 'application/vnd.ms-excel',
    });
    let options = new RequestOptions({ headers });

    // return this.http.post(env + 'CoreOrganization/GetOrganizationMetrics', body, { responseType: ResponseContentType.Blob, headers  })
    return this.http.post(env + 'CoreOrganization/GetOrganizationMetrics', body, options)
      .map((res: Response) => {        
        
        return res.json();
      })
      .catch(this.handleError);
  }

  getMetricDownloadableReport(metricObject): Observable<any> {
    let body = metricObject;
    let headers = new Headers({ 
      'Authorization': `bearer ${localStorage.getItem('bearer')}`,
      'Accept': 'application/vnd.ms-excel',
    });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/GetMetricDownloadableReport', body, { responseType: ResponseContentType.Blob, headers  })
      .map((res: Response) => {        
        var blob = new Blob([res.blob()], { type: 'application/vnd.ms-excel' });

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, 'metric-data.xlsx');
        }
        else {
          saveAs(blob, 'metric-data.xlsx');
        }
      })
      .catch(this.handleError);
  }

  getAdvisorMetricData(metricObject): Observable<any> {
    let body = metricObject;
    let headers = new Headers({ 
      'Authorization': `bearer ${localStorage.getItem('bearer')}`,
      'Accept': 'application/vnd.ms-excel',
    });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/GetAdvisorMetrics', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  getClientMetricData(metricObject): Observable<any> {
    let body = metricObject;
    let headers = new Headers({ 
      'Authorization': `bearer ${localStorage.getItem('bearer')}`,
      'Accept': 'application/vnd.ms-excel',
    });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/GetClientMetrics', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  getGlobalOAMetricData(metricObject): Observable<any> {
    let body = metricObject;
    let headers = new Headers({ 
      'Authorization': `bearer ${localStorage.getItem('bearer')}`,
      'Accept': 'application/vnd.ms-excel',
    });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/GetGlobalOAMetrics', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  getGlobalMetricData(metricObject): Observable<any> {
    let body = metricObject;
    let headers = new Headers({ 
      'Authorization': `bearer ${localStorage.getItem('bearer')}`,
      'Accept': 'application/vnd.ms-excel',
    });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/GetGlobalMetrics', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  getGlobalSearchMetricData(metricObject): Observable<any> {
    let body = metricObject;
    let headers = new Headers({ 
      'Authorization': `bearer ${localStorage.getItem('bearer')}`,
      'Accept': 'application/vnd.ms-excel',
    });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/GetGlobalSearchMetrics', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  private handleError(error: any) {
    if (error.status === 401) {
      // BOTH
      localStorage.clear();
      window.location.href = window.location.origin;
    }

    return Observable.throw(error);
  }

  //ZSS added this for the Public pages
  post<T>(url: string, model: any): Observable<any> {
    let body = model;

    return this._http.post(env + url, body, {
      headers: new HttpHeaders().set('Content-Type', 'application/json')
        .set('Accept', 'application/json')
    })
      .catch(this.handleError);
  }

  getRiskTolerancePortfolio(riskToleranceModel: any): Observable<any> {
    let body = riskToleranceModel;
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    return this.http.post(env + 'CoreReports/GetRiskTolerancePortfolio', body, options)
    .map((res: Response) => {
      return res.json();
    })
    .catch(this.handleError);
  }


}
